// Preserve conversation order even when user transcription arrives after the response.
export function applyVoiceEvent(messages, event) {
  const id = event.item_id || event.item?.id;
  if (!id) return messages;
  let role, content, delta = false, interrupted = false;
  if (event.type === 'input_audio_buffer.speech_started') role = 'user';
  if (event.type === 'response.output_item.added' && event.item?.role === 'assistant') role = 'assistant';
  if (event.type === 'conversation.item.input_audio_transcription.delta') { role = 'user'; content = event.delta; delta = true; }
  if (event.type === 'conversation.item.input_audio_transcription.completed') { role = 'user'; content = event.transcript; }
  if (event.type === 'response.output_audio_transcript.delta') { role = 'assistant'; content = event.delta; delta = true; }
  if (event.type === 'response.output_audio_transcript.done') { role = 'assistant'; content = event.transcript; }
  if (event.type === 'conversation.item.truncated') { role = 'assistant'; interrupted = true; }
  if (!role) return messages;
  const existing = messages.find(message => message.id === id);
  const next = { id, role, content: '', ...existing, interrupted: interrupted || existing?.interrupted || false };
  if (content !== undefined) next.content = (delta ? next.content + content : content).slice(0, 4000);
  if (existing) return messages.map(message => message.id === id ? next : message);
  if (messages.length >= 120) return messages;
  return [...messages, next];
}